import type { Speaker, SynthesizeSpeechCommand } from '@/api-gen/api.schemas';
import type { UseQueryOptions } from '@tanstack/react-query';
import { speechGetVoiceList, speechSynthesizeSpeech } from '@/api-gen/api.ts';

/**
 * Get list of all voices possible to use
 */
export const voicesQuery: UseQueryOptions<Speaker[]> = {
  queryKey: ['voicesQuery'],
  queryFn: async (): Promise<Speaker[]> => {
    const { data } = await speechGetVoiceList();
    return (data as any) ?? data;
  },
  refetchOnMount: false,
  refetchOnWindowFocus: false
};

/** Get a synthesized speech's audio data */
export const getSynthesizeSpeechAudioQuery = (
  payload: SynthesizeSpeechCommand | undefined
): UseQueryOptions<string> => ({
  queryKey: ['synthesizeSpeechQuery', payload],
  queryFn: async () => {
    // Orval client: returns AxiosResponse<string>
    const response = await speechSynthesizeSpeech(payload as any);
    return `data:audio/mpeg;base64,${response.data}`;
  },
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  enabled: !!payload,
  staleTime: 5 * 60 * 1000
  // set long cache time
});
